// IMPORTANT: Replace with your project's actual Firebase configuration.
// You can find this in the Firebase console for your web app.
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAweslIEi7VfjM7Z-KT7VfB0Ra-_qCjSZE",
    authDomain: "veydra-cloud.firebaseapp.com",
    projectId: "veydra-cloud",
    storageBucket: "veydra-cloud.firebasestorage.app",
    messagingSenderId: "952497339614",
    appId: "1:952497339614:web:8a99b01c3f0547078bd64f",
    measurementId: "G-F529HVEN94"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const isLocalhost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

// For local dev, use Firebase App Check debug token flow.
// Set REACT_APP_APPCHECK_DEBUG_TOKEN to either:
// - true (auto-generate token; copy from console and allowlist in Firebase), or
// - an explicit debug token string already allowlisted in Firebase Console.
if (isLocalhost && process.env.REACT_APP_APPCHECK_DEBUG_TOKEN) {
  window.FIREBASE_APPCHECK_DEBUG_TOKEN =
    process.env.REACT_APP_APPCHECK_DEBUG_TOKEN === 'true'
      ? true
      : process.env.REACT_APP_APPCHECK_DEBUG_TOKEN;
}

// Initialize App Check with reCAPTCHA v3
const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('6LcJxFssAAAAALINlGYoDMM58GPJhBg28Pq-rlh4'),
  isTokenAutoRefreshEnabled: true
});

const db = getFirestore(app);

// NOTE: Firebase Analytics has been moved to Google Tag Manager (GTM-M9353VH9)
// and is now consent-gated via Consent Mode v2. Do not re-add getAnalytics() here.

export { db, appCheck };